import React from 'react';
import { compose, pure } from 'recompose';
import RangeSlider from './RangeSlider';
import './PremiumLeadsRange.scss';
import { ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL } from '../../../../common/commonConstants';

export const MIN = 200;
export const MAX = 500;
export const STEP = 50;

type Props = {
  value: number;
  setValue: (...args: any) => void;
  onlineUpgradeOffer: string;
}

/**
 * A component to show the PremiumLeadsRange for LeadsCalculator
 * @returns {Node}
 * @example
 * <PremiumLeadsRange
 *    value={300}
 *    setValue={() => {}}
 *  />
 */
const PremiumLeadsRange = (props: Props): Node => {
  const {
    value,
    setValue,
    onlineUpgradeOffer,
  } = props;
  const isLowCostTrial = onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL;

  return (
    <div className="premium-leads-range-container">
      <div className="premium-leads-slider-container">
        <RangeSlider
          min={MIN}
          max={MAX}
          step={STEP}
          value={value}
          setValue={setValue}
          onlineUpgradeOffer={onlineUpgradeOffer}
          bubbleContent={
            <div className="premium-leads-slider-bubble-container">
              <div className={isLowCostTrial && 'premium-leads-slider-bubble'}><strong>${value}</strong>/mo</div>
              {isLowCostTrial &&
              <div>
                <strong>FREE</strong>
              </div>}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default (compose(pure)(PremiumLeadsRange): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/PremiumLeadsRange.js